import { Breadcrumbs as BreadcrumbsMUI, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import "./Breadcrumbs.css";

const Breadcrumbs = (props) => {
    const { breadcrumbs } = props;

    return (
        <BreadcrumbsMUI
            separator=">"
            aria-label="breadcrumb"
            className="breadcrumbs"
        >
            {breadcrumbs.map((breadcrumb, index) => {
                const isLast = index === breadcrumbs.length - 1;

                if (isLast || breadcrumb.current) {
                    return (
                        <Typography key={index}>
                            {breadcrumb.label}
                        </Typography>
                    );
                }

                return (
                    <Link key={index} href={breadcrumb.href} to={breadcrumb.href}>
                        {breadcrumb.label}
                    </Link>
                );
            })}
        </BreadcrumbsMUI>
    );
};

export default Breadcrumbs;
